<template>
  <div class="container" id="container">
    <div id="dashboard" >
      <!-- Dashboard header -->
      <div class="dashboard__header mb-4 row no-gutters">

        <!-- Dashboard Title -->
        <!-- col-md-4  -->
        <div class="col-sm-12 pt-md-1 pt-sm-0 dashboard__header--col" ref="topTitle">
          <div>
            <svg class="dashboard__header--icon h-100 display-inline-block display-table-cell" width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.625 18.75C19.3003 18.75 18.0828 19.2081 17.1217 19.9743L11.1166 16.2212C11.2945 15.4167 11.2945 14.5832 11.1166 13.7788L17.1217 10.0256C18.0828 10.7919 19.3003 11.25 20.625 11.25C23.7316 11.25 26.25 8.73158 26.25 5.625C26.25 2.51842 23.7316 0 20.625 0C17.5184 0 15 2.51842 15 5.625C15 6.04441 15.0463 6.45293 15.1334 6.84615L9.12832 10.5993C8.16721 9.83315 6.94969 9.375 5.625 9.375C2.51842 9.375 0 11.8934 0 15C0 18.1066 2.51842 20.625 5.625 20.625C6.94969 20.625 8.16721 20.1669 9.12832 19.4007L15.1334 23.1538C15.0446 23.5548 14.9999 23.9643 15 24.375C15 27.4816 17.5184 30 20.625 30C23.7316 30 26.25 27.4816 26.25 24.375C26.25 21.2684 23.7316 18.75 20.625 18.75Z" fill="#2B4D75"/>
            </svg>

            <h1 class="dashboard__header--title m-0 header display-table-cell">Affiliates</h1>
            <!-- <button class="btn btn--white" @click="getTemplate()">Generate</button> -->
          </div>
        </div>

        <!-- Date Range -->
        <!-- <div class="col-sm-12 col-md-8 text-right dashboard__header--col-right">
          <div class="dashboard__header--picker display-table-cell mt-sm-2 mt-md-2 mt-lg-0 display-inline-block">
            <date-range-picker @toggle="detectDateRangeState" v-clickaway="closeDateRangePicker" @update="updateDatee" ref="picker" opens="left" :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' }" :showWeekNumbers="false" :timePicker="false" :autoApply="false" v-model="showDateRange" placeholder="mm/dd/yyyy">
              <div slot="input" slot-scope="picker">
                  <button class="btn btn--white display-table px-3" ref="btn-picker">
                      <svg class="display-table-cell mr-2" width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.4062C0 16.2861 0.713867 17 1.59375 17H13.2812C14.1611 17 14.875 16.2861 14.875 15.4062V6.375H0V15.4062ZM2.125 9.03125C2.125 8.73906 2.36406 8.5 2.65625 8.5H12.2188C12.5109 8.5 12.75 8.73906 12.75 9.03125V11.1562C12.75 11.4484 12.5109 11.6875 12.2188 11.6875H2.65625C2.36406 11.6875 2.125 11.4484 2.125 11.1562V9.03125ZM13.2812 2.125H11.6875V0.53125C11.6875 0.239062 11.4484 0 11.1562 0H10.0938C9.80156 0 9.5625 0.239062 9.5625 0.53125V2.125H5.3125V0.53125C5.3125 0.239062 5.07344 0 4.78125 0H3.71875C3.42656 0 3.1875 0.239062 3.1875 0.53125V2.125H1.59375C0.713867 2.125 0 2.83887 0 3.71875V5.3125H14.875V3.71875C14.875 2.83887 14.1611 2.125 13.2812 2.125Z" fill="#52749C"/>
                      </svg>
                      <span class="display-table-cell" v-if="picker.startDate == null && picker.endDate == null">Select date range</span>
                      <span class="display-table-cell mx-2" v-else>{{dateFormat(picker.startDate)}} - {{dateFormat(picker.endDate)}}</span>
                      <svg class="display-table-cell" width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.594098 0.908325L8.22252 0.908325C8.75074 0.908325 9.01526 1.54697 8.64176 1.92047L4.82755 5.73468C4.59602 5.96621 4.2206 5.96621 3.98907 5.73468L0.174856 1.92047C-0.198674 1.54697 0.0658798 0.908325 0.594098 0.908325Z" fill="#52749C"/>
                      </svg>
                  </button>
              </div>
            </date-range-picker>
          </div>
        </div> -->

      </div>

      <!-- Table -->
      <div id="products-table">
        <!-- v-if="(affiliatesList && affiliatesList.length && !loading) || showSearch" -->
        <div class="products-table__search" >
          <s-input placeholder="Search for an affiliates by a user’s name or email" v-model="searchAffiliates"></s-input>
        </div>
        <s-card class="products-table__card border-top-0 p-0">
          <s-card-body class="product-table__table p-0">
              <div class="product-table__table-container" @scroll="getScrollPos">
                  <div class="div-shadow-left" v-if="!hideShadows && scrollIn && scrollIn !== 'left' && affiliatesList && affiliatesList.length"></div>
                  <!-- affiliatesList && affiliatesList.length &&  -->
                  <!-- 1631px -->
                  <!-- style="width: 1631px;" -->
                  <table v-if="!loading || showSearch" class="product-table__table--table w-content" id="myTable">
                      <thead class="product-table__table--header border-0 p-0 mb-4">
                          <!-- Affiliates ID -->
                          <td class="text-truncate product-table__table--header-id">
                              <span>ID</span>
                          </td>
                          <!-- Name -->
                          <td class="text-truncate product-table__table--header-joined">
                              <span>Name</span>
                          </td>
                          <!-- Stores -->
                          <!-- <td class="text-truncate product-table__table--header-domain">
                              <span>Stores</span>
                          </td> -->
                          <!-- JOINED -->
                          <td class="text-truncate product-table__table--header-joined cursor-pointer">
                              <span>JOINED</span>
                              <!-- <svg class="ml-2"  width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.741224 -3.23999e-08L10.2588 -4.48426e-07C10.9178 -4.77233e-07 11.2479 0.894104 10.7819 1.417L6.02307 6.75689C5.73421 7.08103 5.26581 7.08103 4.97694 6.75689L0.218158 1.417C-0.247875 0.894104 0.0821946 -3.59285e-09 0.741224 -3.23999e-08Z" fill=" #2ecc71"/></svg> -->
                          </td>
                          <!-- Last Active -->
                          <td class="text-truncate product-table__table--header-joined cursor-pointer">
                              <span>Last Active</span>
                          </td>
                          <td class="text-truncate product-table__table--header-domain cursor-pointer">
                              <span>Email</span>
                          </td>
                          <td class="text-truncate product-table__table--header-domain cursor-pointer">
                              <span>Paypal Email</span>
                          </td>
                          <!-- TRIAL END ON -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Discount</span>
                          </td>
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Status</span>
                          </td>
                          <!-- MAUTIC LINK -->
                          <!-- <td class="text-truncate product-table__table--header-mautic-link">
                              <span>MAUTIC LINK</span>
                          </td> -->
                          <!-- Details -->
                          <td class="text-truncate product-table__table--header-trail-started">
                              <span>Details</span>
                          </td>
                      </thead>
                      <tbody class="product-table__table--body">
                          <tr class="w-100 display-table-cell" v-if="loading && showSearch">
                              <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                          </tr>
                          <tr class="w-100 display-table-cell" v-if="!loading && (affiliatesList == null || affiliatesList.length == 0)">
                              <p class="my-3 position-relative font-weight-sbold" style="left:40%;">No Results</p>
                          </tr>
                          <div v-if="affiliatesList && affiliatesList.length > 0">
                            <tr  v-show="!loading" v-for="(affiliates, affiliatesIndex) in affiliatesList" :key="affiliatesIndex" class="product-table__table--row w-100 ">
                                <!-- Affiliates ID -->
                                <td  class="display-table-cell product-table__table--body-id position-relative">
                                  <p class="text-truncate text-right">{{affiliates.id}}</p>
                                  <span v-if="affiliates.payouts.find(element => element.status == 'UPCOMING')" class="product-table__table--row-requested">requested</span>
                                </td>
                                <!-- Name -->
                                <td :tooltip-position="affiliatesIndex==0?'right':'top'" :tooltip="affiliates.name" class="display-table-cell product-table__table--body-joined">
                                  <p  class="text-truncate">{{affiliates.name}}</p>
                                </td>
                                <!-- JOINED -->
                                <td class="display-table-cell product-table__table--body-joined">
                                    <p class="text-truncate">{{affiliates.created_at?fromNow(affiliates.created_at):'-'}}</p>
                                </td>
                                <!-- Last Active -->
                                <td class="display-table-cell product-table__table--body-joined">
                                    <p class="text-truncate">{{affiliates.updated_at?fromNow(affiliates.updated_at):'-'}}</p>
                                </td>
                                <td class="display-table-cell product-table__table--body-domain">
                                    <p class="text-truncate">{{affiliates && affiliates.email ?affiliates.email:'-'}}</p>
                                </td>
                                <td class="display-table-cell product-table__table--body-domain">
                                    <p class="text-truncate">{{affiliates && affiliates.paypal_email ?affiliates.paypal_email:'-'}}</p>
                                </td>
                                <!-- TRIAL END ON -->
                                <td class="display-table-cell product-table__table--body-trail-started">
                                    <p class="text-truncate">{{affiliates.discount || affiliates.discount == 0 ?affiliates.discount:'-'}}</p>
                                    <!-- <s-toggle :class="affiliates.loadingChangeApprove ? 'disabled':''" @input="toggleApprovation($event,affiliates)" class="display-table-cell" v-model="affiliates.approved"></s-toggle> -->
                                </td>
                                <td class="display-table-cell product-table__table--body-trail-started">
                                    <!-- <p class="text-truncate">{{affiliates.trial_end_at?fromNow(affiliates.trial_end_at):''}}</p> -->
                                    <s-toggle :class="affiliates.loadingChangeApprove ? 'disabled':''" @change="toggleApprovation($event,affiliates)" class="display-table-cell" v-model="affiliates.approved"></s-toggle>
                                </td>
                                <!-- Details -->
                                <td class="display-table-cell product-table__table--body-trail-started">
                                    <button @click="affiliatesDetails(affiliates.id)" class="btn btn--primary display-table-cell">
                                      <span class="display-table-cell">Details</span>
                                    </button>
                                </td>

                            </tr>
                          </div>

                      </tbody>
                  </table>
                  <table v-else-if="loading" class="product-table__table--table" style="width: 100%;" id="myTable">
                    <tbody class="product-table__table--body">
                      <tr class="w-100 display-table-cell">
                        <s-loader :type="'scalify'" class="my-3" style="left:calc(50% - 42px);position:relative;"></s-loader>
                      </tr>
                    </tbody>
                  </table>
                  <div class="div-shadow-right" v-if="!hideShadows && scrollIn && scrollIn !== 'right' && ((affiliatesList && affiliatesList.length)||showSearch)"></div>
              </div>
          </s-card-body>
          <s-card-body v-if="affiliatesList && affiliatesList.length && !showSearch && loadMoreAffiliatess && !loading" class="p-0 product-table__load-more text-center">
              <button v-if="!loadingLoadMore" class="btn btn--white" @click="loadMoreAffiliatessDetails()">Load More</button>
              <s-loader :type="'scalify'" v-else></s-loader>
          </s-card-body>
        </s-card>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
// import DateRangePicker from 'vue2-daterange-picker';
// import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'


export default {
  name: 'dashboard',

  components:{
    // MiniChart,
    // DateRangePicker
  },

  props: {},

  computed:{
  },

  data(){
    return{
      showDateRange: {},
      valueUpdateDate: null,
      showRangePicker:false,
      affiliatesList: [],
      searchAffiliates: "",
      showSearch: false,
      showColumns: false,
      loading:false,
      hideShadows:false,
      scrollIn:"left",
      loadMoreAffiliatess: true,
      loadingLoadMore: false,
      showStores:[],
      currentPage: 1,
      isLoadMoreSearch: false
    }
  },

  methods:{
    async toggleApprovation(event,item){
        // console.log("event,item",event,item)
        // return
        item.loadingChangeApprove = true
        this.$forceUpdate()
        let status = await this.toggleAffiliate(event,item.id)
        // console.log("statuuuuuus",status)
        if(status){
            item.approved = status.approved
        }
        else{
            item.approved = !event
        }
        item.loadingChangeApprove = false
        this.$forceUpdate()
    },
    affiliatesDetails(affiliatesID){
      this.$router.push(`/affiliates/${affiliatesID}`);
        // console.log("not yet",affiliatesID)
    },
    // showAffiliatesStores(affiliatesIndex){
    //   console.log('affiliatesIndex: ', affiliatesIndex);
    //   this.showStores[affiliatesIndex] = !this.showStores[affiliatesIndex]
    //   this.$forceUpdate();
    // },
    // closeDateRangePicker(){
    //   this.$nextTick(()=>{
    //     if(this.showRangePicker){
    //       this.$refs["btn-picker"].click()
    //     }
    //   })
    // },
    // detectDateRangeState(show){
    //   this.showRangePicker = show
    // },
    // async updateDatee(value){
    //   this.valueUpdateDate = value;
    //   this.loading = true;
    //   let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
    //   let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
    //   const affiliates = await this.affiliatesTable(start,end);
    //   if (affiliates && affiliates.data) {
    //     this.affiliatesList = affiliates.data;

    //     if (affiliates.data.length >= 25) {
    //       this.linkLoadMoreTasks = true;
    //     }else{
    //       this.linkLoadMoreTasks = false;
    //     }
    //   }
    //   this.isLoadMoreSearch = false;
    //   this.loading = false;
    // },
    dateFormat(date){
      const m = moment(date);
      const ord = m.format("ll");
      return ord;
    },
    getScrollPos ({ target: { scrollLeft ,clientWidth, scrollWidth }}) {
      var scroll = "left"
      if(scrollLeft == 0){
          scroll = "left"
      }
      else if(scrollLeft+clientWidth < scrollWidth){
          scroll = "middle"
      }
      if(scrollLeft+clientWidth >= scrollWidth){
          scroll = "right"
      }
      this.scrollIn = scroll
    },
    updateTableWidth(){
      this.$nextTick(()=>{
        var x = document.getElementById("myTable")
        if(x){
            var items = x.children[0].children
            var w = 0
            for(var i=0;i<items.length;i++){
                w = w + items[i].clientWidth
            }
            if(parseInt(w) < 1110){
                this.hideShadows = true
            }
            else{
                this.hideShadows = false
            }
            x.style.width=w+'px'
            this.$forceUpdate()
        }
      })
    },
    async loadMoreAffiliatessDetails(){
      try {

        this.loadingLoadMore = true;
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        let  detailsAffiliatess;
        this.currentPage++;
        if (this.isLoadMoreSearch) {
          detailsAffiliatess = await this.affiliatesTable(start,end,this.currentPage);
        }else{
          detailsAffiliatess = await this.affiliatesSearch(this.searchAffiliates,this.currentPage)
        }
        console.log('detailsAffiliatess: ', detailsAffiliatess);
        if (detailsAffiliatess && detailsAffiliatess.data) {
          this.affiliatesList = this.affiliatesList.concat(detailsAffiliatess.data);
          if (detailsAffiliatess.data.length > 0) {
            detailsAffiliatess.data.map(()=>{
              this.showStores.push(false);
            })
          }
          this.currentPage = detailsAffiliatess.currentPage;
          if (detailsAffiliatess && detailsAffiliatess.data && detailsAffiliatess.data.length >= 25) {
            this.loadMoreAffiliatess = true;
          }else{
            this.loadMoreAffiliatess = false;
          }
        }else{
          this.loadMoreAffiliatess = false;
        }
        this.loadingLoadMore = false;
      } catch (error) {
        this.loadingLoadMore = false;
      }
    }

  },

  async created(){
    this.showDateRange = {};
    this.showDateRange['endDate'] = new Date();
    var makeDate = new Date();
    this.showDateRange['startDate'] = new Date(new Date().setMonth(makeDate.getMonth()-1));
  },

  watch:{

    async searchAffiliates(){


      if (this.searchAffiliates == "") {
        this.loading = true;
        this.showSearch = true
        let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
        let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
        const affiliates = await this.affiliatesTable(start,end);
        if (affiliates && affiliates.data) {
          this.affiliatesList = affiliates.data;
          if (this.affiliatesList.length >= 25) {
            this.loadMoreAffiliatess = true;
          }else{
            this.loadMoreAffiliatess = false;
          }
          if (this.affiliatesList.length > 0) {
            this.showStores = [];
            this.affiliatesList.map(()=>{
              this.showStores.push(false);
            })
          }
        }
        this.isLoadMoreSearch = false;
        this.loading = false;
        this.showSearch = false

      }else if(this.searchAffiliates.length >= 3){
        this.loading = true;
        this.showSearch = true
        var t = 1000;

        clearTimeout(window.popTimeout);

        window.popTimeout = setTimeout(async () => {
          const resultSearch = await this.affiliatesSearch(this.searchAffiliates);
          console.log('resultSearch: ', resultSearch);
          this.affiliatesList = resultSearch.data;
          if (this.affiliatesList.length >= 25) {
            this.loadMoreAffiliatess = true;
          }else{
            this.loadMoreAffiliatess = false;
          }
          if (this.affiliatesList && this.affiliatesList.length > 0) {
            this.showStores = [];
            this.affiliatesList.map(()=>{
              this.showStores.push(false);
            })
          }
          this.isLoadMoreSearch = true;
          this.showSearch = false
          this.loading = false;
        }, t);
      }

    }

  },

  async mounted(){

    this.loading = true
    let start = moment(this.showDateRange.startDate).format('YYYY-MM-DD');
    let end = moment(this.showDateRange.endDate).format('YYYY-MM-DD');
    const affiliates = await this.affiliatesTable(start,end,this.currentPage);
    console.log('affiliates: => ', affiliates);
    if (affiliates && affiliates.data) {
      this.affiliatesList = affiliates.data;
      if (this.affiliatesList.length > 0) {
        this.affiliatesList.map(()=>{
          this.showStores.push(false);
        })
      }

      if (affiliates && affiliates.data && affiliates.data.length >= 25) {
        this.loadMoreAffiliatess = true;
      }else{
        this.loadMoreAffiliatess = false;
      }
    }
    this.loading = false
  }


}
</script>

<style scoped>

</style>
